<template>
<v-card flat class="mt-4">
    <v-card-text>
        <p class="text-h6 text--primary mb-8">
            {{title}}
        </p>
        <v-data-table :headers="headers" :items="itemList" :hide-default-footer="true" :loading="isExporting" :items-per-page="itemList.length"></v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
import formatData from "../utils/formatData";
import {
    onsiteConfig
} from '@/helpers/onsiteConfig'
export default {
    data() {
        return {
            title: 'ข้อมูลการให้คำปรึกษา on-site',
            onsiteConfig: onsiteConfig,
            search: "",
            options: {
                itemsPerPage: 20,
            },
            isExporting: false,
            headers: [{
                text: "name",
                value: "name",
                sortable: false
            }],
            itemList: []
        };
    },
    created() {
        (async () => {
            for (let i = 1; i <= this.programInfo['memberOnsite']; i++) {
                this.headers.push({
                    text: "onsite " + i,
                    value: "onsite" + i,
                    sortable: false
                });
            }
            this.headers.push({
                text: 'ค่ามาตรฐาน',
                value: 'target',
                sortable: false
            });
            this.headers.push({
                text: '% เทียบก่อนหลัง',
                value: 'percentDiff',
                sortable: false
            });

            for (const [key] of Object.entries(onsiteConfig['defaultItem']['onsiteReport'])) {
                if (onsiteConfig['defaultItem']['onsiteReport'][key]['field'] != undefined) {

                    //set name
                    const itemListHash = {
                        name: onsiteConfig['defaultItem']['onsiteReport'][key]['title'],
                    };

                    //set target
                    let target = '';
                    if (this.programInfo['target'] != undefined && this.programInfo['target'][key] != undefined && this.programInfo['target'][key] != '' ) {
                        target = this.programInfo['target'][key];
                    }
                    itemListHash['target'] = target;

                    //set onsite value
                    for (let i = 1; i <= this.programInfo['memberOnsite']; i++) {
                        let value = '-';
                        if (this.programInfo['onsite'] != undefined && this.programInfo['onsite']['onsite' + i] != undefined && this.programInfo['onsite']['onsite' + i][key] != undefined && this.programInfo['onsite']['onsite' + i][key] != '' ) {
                            value = this.programInfo['onsite']['onsite' + i][key];
                            if( key == 'date' ){
                                value = formatData('date', this.programInfo['onsite']['onsite' + i][key].toDate());
                            }
                        }
                        itemListHash['onsite' + i] = value;
                    }

                    //TODO calculate before and after
                    //TODO calculate only field match for 1 & 6
                    //TODO skip if empty or undef value
                    itemListHash['percentDiff'] = '-';
                    if (itemListHash['onsite1'] != '-' && itemListHash['onsite' + this.programInfo['memberOnsite']] != '-') {
                        itemListHash['percentDiff'] = ((itemListHash['onsite' + this.programInfo['memberOnsite']] - itemListHash['onsite1']) / itemListHash['onsite1']) * 100;
                        itemListHash['percentDiff'] = formatData('number', itemListHash['percentDiff']);
                    }

                    this.itemList.push(itemListHash);
                }
            }
        })();
    },
    computed: {
        programInfo() {
            return this.$attrs.programInfo;
        }
    },
    methods: {
        
    }
};
</script>
